<ng-template [ngIf]="item">
    <a class="block mx-2 mb-4 transition-shadow duration-200"
        (mouseenter)="onCardMouseEnter()"
        (mouseleave)="onCardMouseLeave()"
        prefetch='intent'
        [routerLink]="linkCommands"
        [queryParams]="{ variantid: variantId }"
        [state]="{ from: currentUrl }"
        [ngClass]="[
            'hover:shadow-lg border border-transparent hover:border-gray-200',
            roundedClass
        ]"
        [class.is-hover]="hover"
    >
        <div class="relative w-full h-full full-size mb-4"
                (mouseenter)="onMouseEnter()"
                (mouseleave)="onMouseLeave()">
            <div class="aspect-ratio-container"
                [ngClass]="[
                    imgType,
                    roundedClass,
                    hoverCard ? 'rounded-b-none' : roundedClass
                ]">
                <img
                    *ngIf="!featuredAsset?.videoUrl"
                    loading="lazy"
                    [src]="featuredAsset | assetPreview:'medium':'webp'"
                    [alt]="itemName"
                    style="pointer-events: none;"
                    [ngClass]="{'product-image rectangle w-full h-full object-cover aspect-[1/1]': imgType === 'rectangle',
                                'product-square-image square w-full h-full object-cover aspect-[1/1]': imgType === 'square'}"
                />
                <div *ngIf="featuredAsset?.videoUrl && cardWidth" class="absolute inset-0">
                    <vsf-vimeo-player
                        [source]="featuredAsset.videoUrl"
                        [width]="cardWidth"
                        [height]="cardHeight"
                        [previewImageUrl]="featuredAsset.imageUrl || featuredAsset.preview"
                        [previewAltText]="itemName">
                    </vsf-vimeo-player>
                </div>
            </div>
        </div>
        <div class="product-name font-bold my-2 text-[#2E3742] px-2 md:px-3" [title]="itemName">
            {{ itemName }}
        </div>
        <div *ngIf="displaySubtitle" class="product-subtitle my-2 text-[#95A1AF] px-2 md:px-3" [title]="item.productSubtitle" >
            {{ item.productSubtitle || '&nbsp;' }}
        </div>
        <div *ngIf="displayPrice"
            class="flex flex-col product-price font-medium font-semibold text-[#2E3742]">
            <ng-container *ngIf="msrp && discountPercentage; else onlyPrice">
                <div class="text-base">
                    <span *ngIf="!isMobile" class="text-grey-500 line-through">
                        {{ msrp | formatPrice }}
                    </span>
                    <span class="text-red-500 ml-2">
                        {{ itemPrice | formatPrice }} ({{ discountPercentage | number:'1.0-0' }}% off)
                    </span>
                </div>
            </ng-container>
            <ng-template #onlyPrice>
                <div>
                    <div *ngIf="item.price.__typename === 'SinglePrice'">
                        {{ itemPrice | formatPrice }}
                    </div>
                    <div *ngIf="item.price.__typename === 'PriceRange'">
                        <ng-template [ngIf]="item.price.min === item.price.max" [ngIfElse]="range">
                            {{ itemPrice | formatPrice }}
                        </ng-template>
                        <ng-template #range>
                            From {{ item.price.min | formatPrice }}
                        </ng-template>
                    </div>
                </div>
            </ng-template>
        </div>
        <div *ngIf="displayBuyButton" class="mt-3 mb-2 flex justify-center">
            <button
                (click)="onButtonClick($event)"
                class="px-4 py-1 whitespace-nowrap rounded-lg border focus:outline-none pointer-events-auto"
                [ngClass]="defaultButtonClasses"
                [ngStyle]="buttonInlineStyle"
                [disabled]="isDisabled">
                {{ inStock ? resolvedButtonText : 'Sold Out' }}
            </button>
        </div>
    </a>
</ng-template>
